import regionmaster from "./regionmaster";
import circlemaster from"./circlemaster";
import subcirclemaster from"./subcirclemaster";
import deptmaster from"./deptmaster";
import subdeptmaster from"./subdeptmaster";
import designationmaster from"./designationmaster";
import educationmaster from"./educationmaster";
import occupationmaster from"./occupationmaster";
import bloodgrpmaster from"./bloodgrpmaster";
import castemaster from"./castemaster";
import partymaster from"./partymaster";
import candidatemaster from"./candidatemaster";
import citymaster from"./citymaster";
import reasonmaster from"./reasonmaster";
import visitreasonmaster from"./visitreasonmaster";
import issuetypemaster from"./issuetypemaster";
import subjectmaster from"./subjectmaster";
import issuestatusmaster from"./issuestatusmaster";
import prioritymaster from"./prioritymaster";
import referencemaster  from"./referencemaster";
import responsibleofficermaster from"./responsibleofficermaster";
import assignedusermaster from"./assignedusermaster";
import outwardsubjectmaster from"./outwardsubjectmaster";
import lettertemplatemaster  from"./lettertemplatemaster";
import eventtypemaster from"./eventtypemaster";
import villagemaster from"./villagemaster";
import boothmaster from"./boothmaster";
// import from"./";
// import from"./";


export default{
  regionmaster,
  circlemaster,
  subcirclemaster,

  deptmaster,
  subdeptmaster,
  designationmaster,
  educationmaster,
  occupationmaster,
  bloodgrpmaster,
  castemaster,
  partymaster,
  candidatemaster,
  citymaster,
  reasonmaster,
  visitreasonmaster,
  issuetypemaster,
  subjectmaster,
  issuestatusmaster,
  prioritymaster,
  referencemaster,
  responsibleofficermaster,
  assignedusermaster,
  outwardsubjectmaster,
  lettertemplatemaster,
  eventtypemaster,
  villagemaster,
  boothmaster,
  
};